export const ENDPOINTS = {
  getSheet: 'https://sheets.googleapis.com/v4/spreadsheets'
} as const
